import React from 'react';
import { useTranslation } from 'react-i18next';
import { Breadcrumb, Col, Row, Skeleton } from 'antd';
import { Profile2User } from 'iconsax-react';
import HomeStatCard from '../../atoms/HomeStatCard';
import TitleText from '../../atoms/TitleText';
import Button from '../../atoms/Button';
import { setModalId } from '../../../store/slices/publicSlice';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  useCanTakeActionQuery,
  useGetDisputeStatsQuery,
} from '../../../store/services/disputeService';
import Helpers from '../../../lib/helpers';

export default function DisputesStats() {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const params = useParams();
  const dispatch = useDispatch();

  const { data, isLoading } = useGetDisputeStatsQuery(
    { disputeId: params?.disputeId },
    {
      refetchOnMountOrArgChange: true,
    }
  );
  const { data: canTakeAction } = useCanTakeActionQuery(
    { disputeId: params?.disputeId },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  if (isLoading) {
    return (
      <div>
        <Row gutter={[16, 16]} data-testid="products-stats-skeleton">
          {new Array(3).fill(0).map((key, idx) => (
            <Col
              span={24}
              sm={12}
              md={6}
              key={idx}
              data-testid={`products-stats-skeleton-col-${idx}`}
            >
              <div className="flex gap-3 bg-white dark:bg-gray-900 rounded-xl border border-gray-100 dark:border-gray-800 px-4 py-8 shadow-sm">
                <div className="flex items-start pt-1">
                  <div className="w-10 h-10 rounded-full bg-gray-100" />
                </div>
                <div className="flex flex-col gap-2 flex-1">
                  <Skeleton.Input
                    active
                    size="small"
                    style={{ width: '70%' }}
                  />
                  <Skeleton.Input
                    active
                    size="default"
                    style={{ width: '50%' }}
                  />
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-y-2  md:gap-y-0 md:flex-row md:items-center md:justify-between">
        <div className="">
          <TitleText
            text={t('components.disputeFeature.disputeDetails')}
            className="!text-[28px] !font-bold"
          />

          <Breadcrumb
            items={[
              {
                title: (
                  <a href="/">{t('components.disputeFeature.dashboard')}</a>
                ),
              },
              {
                title: (
                  <a href={`/${language === 'en-US' ? 'en' : 'ar'}/dispute`}>
                    {t('components.disputeFeature.disputesList')}
                  </a>
                ),
              },
              { title: t('components.disputeFeature.disputeDetails') },
            ]}
          />
        </div>

        {canTakeAction?.payload?.canTakeAction && (
          <Button
            className="min-w-[270px]"
            onClick={() => dispatch(setModalId({ id: `DISPUTE_ACTION` }))}
            size="md"
          >
            {t('components.disputeFeature.takeAction')}
          </Button>
        )}
      </div>

      <div data-testid="products-stats-container">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          <HomeStatCard
            number={`${Helpers.formatMoney(data?.payload?.holdAmount)} ${t('SAR')}`}
            title={t('components.disputeFeature.heldInEscrow')}
            icon={<Profile2User size={20} color="#4DA167" variant="Outline" />}
          />

          <HomeStatCard
            number={`${Helpers.formatMoney(data?.payload?.orderValue)} ${t('SAR')}`}
            title={t('components.disputeFeature.orderValue')}
            icon={<Profile2User size={20} color="#4DA167" variant="Outline" />}
          />

          <HomeStatCard
            number={`${Helpers.formatMoney(data?.payload?.shipmentFee)} ${t('SAR')}`}
            title={t('components.disputeFeature.shipmentFee')}
            icon={<Profile2User size={20} color="#4DA167" variant="Outline" />}
          />
        </div>
      </div>
    </div>
  );
}
